import { getA2APaymentsByCriteria, getCardPaymentsByCriteria } from '@nemuru-eng/js-api-client';

import { ApplicationType, SinglePaymentApplicationType } from '@/config/types';

import { fetchForDataGrid } from '../../../../utils/fetchForDataGrid';

export function useFetchSinglePaymentList({
  applicationType,
  additionalFilters,
}: {
  applicationType: SinglePaymentApplicationType;
  additionalFilters?;
}) {
  const queryAdditionalFilters = additionalFilters ?? [];
  const baseQueryFilters = [...queryAdditionalFilters];

  const fetchSinglePaymentList = async (query) => {
    const customFilters = baseQueryFilters.concat(query?.filters);
    const dataTransform = (result) => ({ ...result, data: result.data });
    return fetchForDataGrid(
      applicationType === ApplicationType.A2A_PAYMENT ? getA2APaymentsByCriteria : getCardPaymentsByCriteria,
      { ...query, filters: customFilters },
      dataTransform,
    );
  };

  return { fetchSinglePaymentList };
}
